import { Component } from 'react';

import RichTextRenderer from '../utils/content/RichTextRenderer';
import RichTextWrapper from './common/RichTextWrapper';

import * as InternalPropTypes from '../constants/internal-types';
import { TypeBackgroundColorTypes } from '../constants/cms-constants';

const styles = {
  '& ul': {
    paddingInlineStart: '40px',
  },
  '& ol': {
    paddingInlineStart: '40px',
  },
};

type TextBoxProps = {
  input?: InternalPropTypes.RichText;
  openInNewTab?: boolean;
  backgroundColor?: TypeBackgroundColorTypes;
};

class TextBox extends Component<TextBoxProps> {
  static defaultProps = {
    input: null,
    openInNewTab: true,
    backgroundColor: null,
  };

  render() {
    const { input, openInNewTab, backgroundColor } = this.props;

    const addStyle = backgroundColor ? { background: backgroundColor } : {};

    return (
      <div css={[styles, addStyle]}>
        <RichTextWrapper
          richText={input}
          renderFunction={(richText, errorReporter) =>
            RichTextRenderer.headersItalicBoldLinksAndLists(
              richText,
              errorReporter,
              openInNewTab,
            )
          }
        />
      </div>
    );
  }
}

export default TextBox;
